import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import React, {useEffect, useRef} from "react";
import {GetConfirmationRequirements} from "../../../Auth/slice";
import {ConfirmCodeForm} from "./ConfirmCodeForm";
import {EnterPhoneForm} from "./EnterPhoneForm";
import {ForeignPhoneForm} from "./ForeignPhoneForm";
import {CloseMobile, NewModal, NewModalContainer} from "../../../../components/ui/Content";
import {useOnClickOutside} from "../../../../hooks/useClickOutside";
import {setChangeDataModal} from "../api/slice";
import {Close} from "../../../../icon/Icon";
import {ChangeSuccess} from "./ChangeSuccess";
import {ChangeDataModalInit} from "../../../../interface/Passport/Account/frontend";
import { setChangeDataForChangeNull, setChangeSuccessFalse } from "../UserInfo/slice";

let modalEl: HTMLDivElement;

export const ChangePhoneModal = () => {

    const dispatch = useAppDispatch()
    const {needPhoneVerification} = useAppSelector(state => state.auth)
    const {changeDataModal} = useAppSelector(state => state.account)
    const {dataForChange, success} = changeDataModal
    const ref = useRef(modalEl);
    const closeModal = () => {
        dispatch(setChangeDataModal(ChangeDataModalInit))
        dispatch(setChangeSuccessFalse())
        dispatch(setChangeDataForChangeNull())
    }
    useOnClickOutside(ref, () => closeModal())

    useEffect(() => {
        dispatch(GetConfirmationRequirements())
    }, [])

    const Content = () => {
        if (success) {
            return <ChangeSuccess/>
        }
        if (needPhoneVerification === false) {
            return <ForeignPhoneForm/>
        }
        if (dataForChange) {
            return <ConfirmCodeForm/>
        }
        return <EnterPhoneForm/>
    }

    return <NewModal>
        <CloseMobile onClick={closeModal}>
            <Close/>
        </CloseMobile>
        <NewModalContainer ref={ref}>
            <Content/>
        </NewModalContainer>
    </NewModal>
}
